import { graphql } from 'react-relay';
import { genericMutation } from '../utils';
import type { ZnglyInfo_UpdateSettings_Mutation } from './__generated__/ZnglyInfo_UpdateSettings_Mutation.graphql';

const UpdateZnglyInfoSettingsMutation = graphql`
  mutation ZnglyInfo_UpdateSettings_Mutation(
    $input: UpdateZnglyInfoInput!
    $isIntegrations: Boolean!
    $isAnalytics: Boolean!
    $isPrivacy: Boolean!
    $isSiteSettings: Boolean!
    $isGlobalStyles: Boolean!
    $isQrCode: Boolean!
    $isBackend: Boolean!
    $isHeader: Boolean!
    $isPage: Boolean!
    $isFooter: Boolean!
    $isHomepage: Boolean!
    $isPersonalisedVideo: Boolean!
    $isChatbot: Boolean!
  ) {
    updateZnglyInfo(input: $input) {
      znglyInfo {
        id
        znglyInfo {
          ...integrations_Settings_Fragment @include(if: $isIntegrations)
          ...analytics_Settings_Fragment @include(if: $isAnalytics)
          ...privacyPolicy_Settings_Fragment @include(if: $isPrivacy)
          ...siteSettings_Settings_Fragment @include(if: $isSiteSettings)
          ...globalStyles_Settings_Fragment @include(if: $isGlobalStyles)
          ...qrCodeTab_Settings_Fragment @include(if: $isQrCode)
          ...backend_Settings_Fragment @include(if: $isBackend)
          ...personalisedVideo_Settings_Fragment @include(if: $isPersonalisedVideo)
          ...header_Settings_Fragment @include(if: $isHeader)
          ...body_Settings_Fragment @include(if: $isPage)
          ...footer_Settings_Fragment @include(if: $isFooter)
          ...homePage_Settings_Fragment @include(if: $isHomepage)
          ...chatbot_Settings_Fragment @include(if: $isChatbot)
        }
      }
    }
  }
`;

export const updateZnglyInfoSettingsMutation = genericMutation<ZnglyInfo_UpdateSettings_Mutation>({
  mutation: UpdateZnglyInfoSettingsMutation,
});
